<template>
<div>
<groups_wrapper :likes='likes'  :groups='groups'> </groups_wrapper>
</div>
</template>


<script>
import axios from 'axios'
import groups_wrapper from './groups_wrapper.vue'
export default {
components:{groups_wrapper},
data(){
return {
likes:{
loadContent:false,
taskList:[],

srcAll:[],
selectedSrc:[],
selector: false,
modals:{
    addSrc:false,
    deleteSrc: false,
    deleteSelected: false,
    checkGroup: false,
    history: false,
    changeCatSelected: false,
    renameCatSelected: false,
    removeCatSelected: false,
    createCat: false,
  },
catList:[],
selectedCat:{
params:{
task_list:[],
update_time:{ sec:30, min:0, hours:0 },
},
},

selected:[],     // !!!!!!!!!!!!!!!!!!!!
selector: false,  // !!!!!!!!!!!!!!!!!!!!
checkList: [],
checker: {

foundData:{
selector: false,
foundIds: [],
displayIds: [],
selectedIds: [],
offset: 0,
},

pages: {
q: "",
offset: 0 ,
displayed: [],
all_in: [],
},

updater: {
id : "",
status : true
},

},

},

groups:{

  removeList: {
    loading: false,
  },
 
  catList: [],

  loading: true,

  selected:[],
  selector: false,

  deleteId: [],
  modals :{
    addGroups:false,
    deleteGroup: false,
    deleteSelected: false,
    checkGroup: true,
    history: false,
    changeCatSelected: false,
    renameCatSelected: false,
    removeCatSelected: false,
  },
  history: {
    inMode:true,
    outMode:false,
    historyId: '',
    foundData:{
     selector: false,
     foundIds: [],
     displayIds: [],
     selectedIds: [],
     offset: 0,
     selectAll: false
   },



    menegerIn: {
        marginTop: '0px',
        snackbarAbsoute: true,
        items: {
          selector: {active:true},
          copy: {active:true},
          export: {active:true},
          update: {active:false},
          delete: {active:false},
          autoExport: {active:false}
        },
        contentInfo: {
          type: 'pages',
        },
        autoExport: {
          isActive: false,
          tasksList:[],
       },
     },
     menegerOut: {
         marginTop: '0px',
         snackbarAbsoute: true,
         items: {
           selector: {active:true},
           copy: {active:true},
           export: {active:true},
           update: {active:false},
           delete: {active:false},
           autoExport: {active:false}
         },
         contentInfo: {
           type: 'pages',
         },
         autoExport: {
           isActive: false,
           tasksList:[],
        },


        }
  },

},
updater: {
  id : "",
  status : true
}

  }
},
created(){
this.likes.loadContent = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {method: 'POST',data: {contentType: 'pages'}})
.then( response => {
this.likes.taskList = response.data
})
if(this.$route.query.cat_id){
this.likes.selectedCat.cat_id = this.$route.query.cat_id
} else{
this.likes.selectedCat.cat_id = 0
}
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/src_get_by_list.php', {
method: 'POST',
data : {catList:this.likes.catList, selectedCat:this.likes.selectedCat },
}).then(response => {
this.likes.loadContent = false
if(response.data.one.src){
this.likes.srcAll = response.data.one.src
this.likes.catList = response.data.one.catList
this.likes.selectedCat = response.data.one.selectedCat
this.$router.push({query: { cat_id: this.likes.selectedCat.cat_id }})
} else this.likes.srcAll = []
})

},


methods:{



  updateGroups: function(data){

    this.groups.lastQ = this.groups.q
    this.groups.all = data

    if(this.groups.all.length > 0 ){

    this.groups.q = "!update"
     }
  },

  deleteGroup: function(list){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_delete.php', {
         method: 'POST', data: {ids:list}
       }).then(response => {
         this.$store.dispatch('changeCounters')
       })


  }
}
}
</script>

<style>
#groups_menegment_wrapper {

  float: left;
  width: 245px;
  height: 300px;

}
#groups_wrapper {

  float: left;
  width: 600px;
  min-height: 300px;

}
</style>
